import { useEffect, useState } from 'react';
import axios from 'axios';
import useLang from './useLang';
import { brusselsToday, upcomingEvents } from '../utils/upcomingEvents';

export default function useUpcomingEvents() {
  const lang = useLang();
  const [result, setResult] = useState({ events: [], lang: null, status: 'loading' });
  const [attempt, setAttempt] = useState(0);
  const [today, setToday] = useState(brusselsToday);
  useEffect(() => {
    const timer = setInterval(() => setToday(brusselsToday()), 60000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    let active = true;
    setResult({ events: [], lang, status: 'loading' });
    axios.get(`${process.env.REACT_APP_BACKEND_URL || ''}/api/events`, { params: { lang, limit: 1000 }, timeout: 15000 })
      .then(({ data }) => {
        if (!Array.isArray(data.events)) throw new Error('Invalid events response');
        if (active) setResult({ events: data.events, lang, status: 'ready' });
      })
      .catch(() => { if (active) setResult({ events: [], lang, status: 'error' }); });
    return () => { active = false; };
  }, [lang, attempt]);
  return {
    events: result.lang === lang ? upcomingEvents(result.events, today) : [],
    status: result.lang === lang ? result.status : 'loading',
    retry: () => setAttempt(value => value + 1),
  };
}
